export default {
  'electronicReportsGrid.reportCode': 'Report Code',
  'electronicReportsGrid.batchNumber': 'Batch Number'
};
